export const homeFaqs = [
  {
    question: 'Who offers occupational skills training near me?',
    answer: 'Occupational Skills Training Center (OST-C) provides comprehensive vocational training, job readiness, and life skills development in Arlington, TX and across the DFW region. Their structured programs are designed to equip individuals with the skills, credentials, and confidence needed to enter and succeed in the workforce.',
  },
  {
    question: 'How much does job training cost?',
    answer: 'Program costs vary depending on the specific training, duration, and individual circumstances. OST-C works with participants to identify funding options, scholarship assistance, and community resources that can reduce or eliminate out-of-pocket costs. Contact our team for a personalized program and cost assessment.',
  },
  {
    question: 'How long do occupational training programs take?',
    answer: 'Program timelines vary based on the training track and individual goals. Many job readiness and life skills programs can be completed in weeks, while vocational certification tracks may take several months. OST-C designs personalized plans to match your timeline, goals, and prior experience for the most efficient path to employment.',
  },
  {
    question: 'Who qualifies for occupational skills training at OST-C?',
    answer: 'OST-C serves a broad range of individuals including first-time job seekers, career changers, returning citizens, individuals facing employment barriers, and those seeking greater independence through skill-building. Programs are accessible, community-centered, and designed to meet participants where they are.',
  },
];

export const aboutFaqs = [
  {
    question: 'What makes OST-C different from other training providers?',
    answer: 'OST-C differentiates through its deeply personalized approach, community-rooted mission, and outcome-focused curriculum. Rather than offering one-size-fits-all training, OST-C builds individualized development plans that address each participant\'s barriers, goals, and strengths — resulting in higher placement rates and longer-term employment outcomes.',
  },
  {
    question: 'What programs does OST-C offer?',
    answer: 'OST-C offers vocational skills training, job readiness and career development, life skills education, employment placement support, community reintegration programs, and workforce development training. Each program is designed around real employment outcomes, not just classroom completion.',
  },
  {
    question: 'Who does OST-C serve?',
    answer: 'OST-C serves individuals at all stages of their workforce journey — including young adults entering the job market, career changers, returning citizens, individuals facing housing instability, and community members who need structured support to achieve lasting independence and employment.',
  },
];

export const locationFaqs = [
  {
    question: 'Do you offer occupational training in Arlington, TX?',
    answer: 'Yes. OST-C is based in Arlington, TX 76006, serving the Arlington community and surrounding DFW cities with vocational training, job readiness programs, and life skills development. Our location is centrally positioned and accessible to participants across the metroplex.',
  },
  {
    question: 'How far is OST-C from me?',
    answer: 'OST-C is located in Arlington, TX, centrally positioned in the DFW metroplex. Participants travel from Fort Worth, Grand Prairie, Mansfield, Euless, Irving, and surrounding cities. Call us at 469-853-5038 to confirm your nearest route and discuss program availability.',
  },
  {
    question: 'Can I enroll quickly at OST-C?',
    answer: 'OST-C offers streamlined enrollment to get you into the right program as quickly as possible. Contact our team at 469-853-5038 or submit an enrollment request online. We understand that every day without employment matters — we prioritize fast, efficient onboarding for every participant.',
  },
];
